import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import ZhiService from "@/core/services/ZhiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store/index";
import {routeMap} from "@/core/data/ConstData";

const state = () => {
  return {
    errors: {},
    user: {
      name: '',
      nickname: '',
      avatar: '',
      avatarNumber: '',
      accountPrivilege: 0,
      type: 2,
      api_token: '',
      resourceList: [],
      resourceCodeList: []
    },
    warningData: {
      cnt: 0,
      nameList: [],
      dataList: {}
    },
    isAuthenticated: !!JwtService.getToken(),
    menuList: [],
    menuActiveIndex: '',
    menuEnterUrl: '',
    resourceList: [],
    resourceCodeList: [],
    engineInfo: {},
    botInfo: {},
    homeType: 1,
  };
};

// getters
const getters = {
  currentUser: (state) => {
    return state.user
  },
  isUserAuthenticated: (state) => {
    return state.isAuthenticated
  },
  getErrors: (state) => {
    return state.errors
  },
  warningData: (state) => {
    return state.warningData;
  },
  menuList: (state) => {
    return state.menuList;
  },
  menuActiveIndex: (state) => {
    return state.menuActiveIndex;
  },
  resourceList: (state) => {
    return state.resourceList
  },
  resourceCodeList: (state) => {
    return state.resourceCodeList
  },
  engineInfo: (state) => {
    return state.engineInfo
  },
  botInfo: (state) => {
    return state.botInfo
  },
  homeType: (state) => {
    return state.homeType
  },
};

// actions
const actions = {
  [Actions.LOGIN]({ commit }, credentials) {
    ApiService.setHeader();
    return ApiService.post("auth/login", credentials)
        .then(({ data }) => {
          commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          commit(Mutations.SET_ERROR, response.data.errors);
        });
  },
  [Actions.LOGOUT]({ commit }) {
    commit(Mutations.PURGE_AUTH);
  },
  [Actions.REGISTER]({ commit }, credentials) {
    return ApiService.post("register", credentials)
        .then(({ data }) => {
          commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          commit(Mutations.SET_ERROR, response.data.errors);
        });
  },
  [Actions.FORGOT_PASSWORD]({ commit }, payload) {
    return ApiService.post("forgot_password", payload)
        .then(() => {
          commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          commit(Mutations.SET_ERROR, response.data.errors);
        });
  },
  [Actions.VERIFY_AUTH]({ commit }, payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.post("auth/verify", payload)
          .then(({ data }) => {
            commit(Mutations.SET_AUTH, data);
          })
          .catch(({ response }) => {
            commit(Mutations.SET_ERROR, response.data.errors);
            commit(Mutations.PURGE_AUTH);
          });
    } else {
      commit(Mutations.PURGE_AUTH);
    }
  },
};

// mutations
const mutations = {
  [Mutations.SET_ERROR](state, { error }) {
    state.errors = { ...error };
  },
  [Mutations.SET_AUTH](state, data) {
    state.isAuthenticated = true;
    let accountInfo = {
      name: data.name,
      nickname: data.nickname,
      avatarNumber: data.avatarNumber,
      type: data.type,
      accountPrivilege: data.accountPrivilege,
      avatar: '/media/avatars/animal/'+data.avatarNumber+'.png'
    };
    state.user = accountInfo;
    state.errors = {};
    ZhiService.saveAccountInfo(accountInfo);
    JwtService.saveToken(data.api_token);
  },
  [Mutations.SET_USER](state, user) {
    state.user = user;
  },
  [Mutations.SET_PASSWORD](state, { password }) {
    state.user.password = password;
  },
  [Mutations.SET_AVATAR_NUMBER](state, payload) {
    let accountInfo = state.user;
    accountInfo['avatarNumber'] = payload;
    ZhiService.saveAccountInfo(accountInfo);
  },
  [Mutations.SET_ACCOUNT_RESOURCE](state, payload) {
    let cResourceList = store.getters.resourceList;
    let uResourceList = payload ? payload : [];
    let uType = state.user.type;
    let rList = [], rCodeList = [];
    if(uType == 1){
      cResourceList.forEach((item) => {
        rCodeList.push(item['code']);
        rList.push(item);
      })
    }else{
      cResourceList.forEach((item) => {
        if(uResourceList.includes(item['id'])){
          rCodeList.push(item['code']);
          rList.push(item);
        }
      })
    }
    state.user.resourceList = rList;
    state.user.resourceCodeList = rCodeList;
  },
  [Mutations.SET_ACCOUNT_WARNING](state, payload) {
    if(payload && payload.length > 0){
      state.warningData['cnt'] = payload.length;
      let nameList = [];
      let dataList = {};
      payload.forEach((item) => {
        nameList.push(item.name);
        dataList[item.name] = item;
      });
      state.warningData['nameList'] = nameList;
      state.warningData['dataList'] = dataList;
    }
  },
  [Mutations.PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = [];
    JwtService.destroyToken();
    ZhiService.destroyAccountInfo();
  },
  [Mutations.SET_ACCOUNT_MENU](state, payload) {
    state.menuList = payload['menu'];
    state.resourceCodeList = payload['resource']
    let resourceList = []
    for(let m1 of state.menuList){
      resourceList.push({
        id: m1['id'],
        code: m1['code']
      })
      if(m1['list']){
        for(let m2 of m1['list']){
          resourceList.push({
            id: m2['id'],
            code: m2['code']
          })
          if(m2['list']){
            for(let m3 of m2['list']){
              resourceList.push({
                id: m3['id'],
                code: m3['code']
              })
            }
          }
        }
      }
    }
    state.resourceList = resourceList;
  },
  [Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX](state, payload) {
    state.menuActiveIndex = String(payload)
  },
  [Mutations.SET_ACCOUNT_ENGINE](state, payload) {
    state.engineInfo = payload
  },
  [Mutations.SET_ACCOUNT_BOT](state, payload) {
    state.botInfo = payload
    if(state.botInfo['bot_list'] && state.botInfo['bot_list'].length > 0 && process.env.VUE_APP_HOME_TYPE == 2){
      state.homeType = 2
    }
  }
};

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
};
